import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `
    <main>
      <router-outlet></router-outlet>
    </main>
  `,
})
export class AppComponent {
  constructor() {
    // console.log('🔍 Angular App Started');
    // console.log('🌍 Environment:', environment.production ? 'PRODUCTION' : 'DEVELOPMENT');

    // console.log('🔗 JIRA Base URL:', environment.jira.baseUrl);
    // console.log('🔑 JIRA Client ID:', environment.jira.clientId);
    // console.log('🔒 JIRA Client Secret:', environment.jira.clientSecret ? 'Present' : 'Not Set');
    // console.log('🔄 JIRA Redirect URI:', environment.jira.redirectUri);
    // console.log('🛠️ JIRA Auth Endpoint:', environment.jira.authorizationEndpoint);
    // console.log('🔑 JIRA Token Endpoint:', environment.jira.tokenEndpoint);
    // console.log('🔍 JIRA Scope:', environment.jira.scope);

    // console.log('🌍 API Base URL:', environment.api.baseUrl);
    // console.log('⏳ API Timeout:', environment.api.timeout);
    // console.log('🔄 API Retry Attempts:', environment.api.retryAttempts);
    
    // If using runtime config.js
    if ((window as any).env) {
      console.log('⚙️ Runtime Environment Variables:', (window as any).env);
    } else {
      console.warn('⚠️ No runtime environment variables found.');
    }
  }
}
